import { combineReducers } from "@reduxjs/toolkit";
import { reducer as toastrReducer } from "react-redux-toastr";
import { persistReducer } from "redux-persist";

import localforage from "localforage";
//Api Reducers
//import { authAPI } from "services/api";

//Reducers
import localesReducer from "locales/localesSlice";
import DrawerReducer from "pages/Drawer/drawerSlice";
import filterParams from "pages/Members/NewFilter/filterSlice";
import classSlice from "pages/School/Classes/classSlice";
import commonSlice from "pages/commonSlice";
import lockLoaderReducer from "pages/lockLoader/lockLoaderSlice";
import { invoicesAPI } from "services/api";
import dashboardData from "../services/api/dashboard";
import education from "../services/api/education";
import events from '../services/api/events';
import communication from "../services/api/communication";
import stepForms from "../services/api/formSteps";
import forms from "../services/api/forms";
import homeReducers from "../store/redux/reducers/Projects";
import fundraisingReducer from "pages/Fundraising/fundraisingSlice";

const educationPersistConfig = {
  key: 'education',
  storage: localforage,
};
const eventPersistConfig = {
  key: 'events',
  storage: localforage,
};

const formsPersistConfig = {
  key: 'forms',
  storage: localforage,
};

const educationPersistReducer = persistReducer(educationPersistConfig, education);
const eventPersistReducer = persistReducer(eventPersistConfig, events);
const formsPersistReducer = persistReducer(formsPersistConfig, forms);
const reducers = combineReducers({
  toastr: toastrReducer,
  lockLoader: lockLoaderReducer,
  locales: localesReducer,
  //auth: authAPI.authSlice.reducer,
  drawer: DrawerReducer,
  stepForms,
  dashboardData,
  filterParams,
  data: classSlice,
  CommonStates: commonSlice,
  getInvoices: invoicesAPI.invoiceSlice.reducer,
  education: educationPersistReducer,
  events:eventPersistReducer,
  homeReducer: homeReducers,
  forms:formsPersistReducer,
  communication,
  fundraising: fundraisingReducer,

});

export default reducers;
